<template>
    <v-tooltip
        :disabled="!isOverflowing || hideValue"
        max-width="1000"
        bottom
    >
        <template v-slot:activator="{ on }">
            <div
                class="sidebar-value pl-2"
                ref="sidebarValue"
                :class="[icon ? 'text-wrapping' : '', showShowIcon ? 'hover-password' : '']"
                v-on="on"
                @mouseover="hoverField(true)"
                @mouseleave="hoverField(false)"
            >
                <icon
                    v-if="icon"
                    small
                    :color="icon.color"
                    :icon="icon.name"
                    class="icon"
                />
                <template v-if="showValueTitle">
                    <span class="body-2 grey--text ml-3">{{ fieldTitle }}</span>&nbsp;
                    <span ref="fieldValueSpan" class="truncated-text">{{ fieldValue }}</span>
                </template>
                <template v-else>
                    <span
                        ref="fieldValueSpan"
                        class="truncated-text"
                        :class="icon ? 'ml-3' : ''"
                    >
                        {{ hideValue ? '*'.repeat(fieldValue.length) : fieldValue }}
                    </span>
                </template>
                <v-tooltip top v-if="showShowIcon">
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :on="on"
                            class="icon-button"
                            xSmall
                            :icon="hideValue ? 'EyeOff' : 'Eye'"
                            @click="hideValue = !hideValue" />
                    </template>
                    {{ hideValue ? $t('Show encrypted data') : $t('Hide encrypted data') }}
                </v-tooltip>
                <v-tooltip top v-if="showCopyIcon">
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :on="on"
                            class="icon-button"
                            xSmall
                            icon="Copy"
                            @click="copyValue"
                        />
                    </template>
                    {{ $t('Copy') }}
                </v-tooltip>
            </div>
        </template>
        <span>{{ fieldValue }}</span>
    </v-tooltip>
</template>

<script>
import {formatCustomFieldValue} from "../../../composables/use-custom-fields";
import {computed, ref, onMounted} from "@vue/composition-api";
import FeedbackNotificationModule from "@/store/modules/feedback_notification";
import {$t} from "../../../i18n";

export default {
    name: "BasicCustomField",
    methods: {formatCustomFieldValue},
    props: {
        relatedObject: {
            type: Object,
            required: true
        },
        field: {
            type: Object,
            required: true
        },
        icon: {
            type: Object,
            default: null
        },
        showValueTitle: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const {showFeedbackNotification} = FeedbackNotificationModule();
        const sidebarValue = ref(null);
        const isOverflowing = ref(false);
        const fieldValueSpan = ref(false)
        const showCopyIcon = ref(false)
        const showShowIcon = ref(false)

        const fieldValue = computed(() => {
            return formatCustomFieldValue(props.field.value, props.field.field, props.relatedObject);
        });

        const fieldTitle = computed(() => {
            return props.field.field.title;
        });

        const isPasswordField = computed(() => props.field.field.type === 'password')

        const hideValue = ref(isPasswordField.value)

        const checkOverflow = () => {
            isOverflowing.value = fieldValueSpan.value.scrollWidth > fieldValueSpan.value.clientWidth;

        };

        const copyValue = () => {
            navigator.clipboard.writeText(fieldValue.value);
            showFeedbackNotification($t('Copied to clipboard'));
        };

        const hoverField = (value) => {
            if (isOverflowing.value || isPasswordField.value) {
                showCopyIcon.value = value
                showShowIcon.value = value && isPasswordField.value
            }
        }

        onMounted(() => {
            setTimeout(() => {
                checkOverflow();
            }, 100);
        });

        return {
            fieldValue,
            fieldTitle,
            sidebarValue,
            isOverflowing,
            fieldValueSpan,
            copyValue,
            showCopyIcon,
            showShowIcon,
            hoverField,
            hideValue,
            isPasswordField
        };
    }
}

</script>

<style scoped lang="scss">
.sidebar-value {
    display: flex;
    align-items: center;
    overflow: hidden;
    font-size: 14px;
    color: var(--v-gray-darken4);
    line-height: 24px;
}

.text-wrapping {
    white-space: nowrap;
}

.truncated-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.icon-button {
    flex-shrink: 0;
    margin-left: 8px;
}

.icon {
    flex-shrink: 0;
}

.hover-password {
    background-color: var(--v-n1-base) !important;
    border-radius: 8px !important;
}

</style>
